import axios from "axios"
import React, { Component } from "react"
import { connect } from "react-redux"
import Loader from "src/components/common/Loader"
import { AppState } from "src/store"
import AxiosConfig from "src/utilities/AxiosConfig"
import EmployeeDataTypes from "../../../Types/EmployeeTypes"
import Reviews from "../../Reviews/Reviews/Reviews"
import ReviewsReferenceTypes from "../../Reviews/Reviews/ReviewsTypes/ReviewsReferenceTypes"
import ReviewsTypes from "../../Reviews/Reviews/ReviewsTypes/ReviewsTypes"
import ReviewApprovalTypes from "../../Reviews/Review/ReviewTypes/ReviewApprovalTypes"
import "./ReviewsDecoupler.css"

interface Props {
    EmployeeID: number | string
    userId: string | number
    ReviewID: string | number
    toggleDecoupler?: Function
    setCompleted: Function
}

type State = {
    reviews: ReviewsTypes[]
    employee: EmployeeDataTypes | {}
    isDelegation: boolean
}

class ReviewsDecoupler extends Component<Props, State> {

    state = {
        reviews: [],
        employee: {},
        isDelegation: false,
        delegatorEmployeeId: -1
    }

    componentDidMount() {
        this.getEmployeeData()
    }

    manageState = (keys: Array<{ key: string, value?: any }>) => {
        let state: any = this.state
        for (let i = 0; i < keys.length; i++) {
            if (Object.entries(keys[i]).length > 1) {
                state[keys[i].key] = keys[i].value
            } else {
                state[keys[i].key] = !state[keys[i].key]
            }
        }
        this.setState(state)
    }



    getEmployeeData = () => {
        axios.get(process.env.REACT_APP_API_URL + "/api/user/getSingleUser/" + this.props.EmployeeID, AxiosConfig.configValue())
            .then(res => {
                this.getReviewReference()
                this.setState({ employee: res.data.users[0] })
            }).catch(err => {
                //console.log(err)
            })
    }


    getReviewReference = () => {
        axios.get(`${process.env.REACT_APP_API_URL}/api/employeereview/reference`, AxiosConfig.configValue("min"))
            .then((res) => {
                this.getReviews(res.data)
            })
            .catch((err) => {
                //console.log("error", err);
                AxiosConfig.handleError(err);
            })
    }


    getReviews = (reference: ReviewsReferenceTypes | null) => {
        this.manageState([{ key: "loading", value: true }])
        axios.get(`${process.env.REACT_APP_API_URL}/api/employeereview/getEmployeeReviewList/${this.props.EmployeeID}`, AxiosConfig.configValue("min"))
            .then((res) => {
                this.manageState(
                    [
                        { key: "reference", value: reference },
                        { key: "reviews", value: res.data },
                        { key: "loading", value: false },
                        { key: "addReview", value: false },
                        { key: "deleteReview", value: false }
                    ])
                this.getReviewApproval(this.props.ReviewID)
            })
            .catch((err) => {
                //console.log("error", err);
                AxiosConfig.handleError(err);
            })
    }

    getReviewApproval = (id: number | string) => {
        axios.get(`${process.env.REACT_APP_API_URL}/api/employeereview/getEmployeeReviewApproval/${id}`, AxiosConfig.configValue("min"))
            .then((res) => {
                const approvals: ReviewApprovalTypes[] = res.data
                // this.handleDelegation(this.getFirstNull(approvals))
            })
            .catch((err) => {
                //console.log("error", err);
                AxiosConfig.handleError(err);
                this.manageState([{ key: "loading", value: false }])
            })
    }

    // handleDelegation = (id: number | string) => {
    //     axios.get(`${process.env.REACT_APP_API_URL}/api/user/AmIDelegate/${id}/2`, AxiosConfig.configValue("min"))
    //         .then((res) => {
    //             this.manageState([{ key: "isDelegation", value: res.data }])
    //             if (res.data === true) {
    //                 this.manageState([{ key: "delegatorEmployeeId", value: id }])
    //             }
    //         })
    //         .catch((err) => {
    //             //console.log("error", err);
    //             AxiosConfig.handleError(err);
    //         })
    // }

    // getFirstNull = (approvals: ReviewApprovalTypes[]) => {
    //     for (let i = 0; i < approvals.length; i++) {
    //         if (!approvals[i].ApprovalDateUTC) {
    //             return approvals[i].ApproverEmployeeId
    //         }
    //     }
    //     return 0
    // }

    render() {

        const props = this.props

        return (
            <div id="reviews-decoupler">
                {this.state.reviews.length === 0 && <div className="ReviewsDecouplerLoading">
                    <span className="material-icons">grading</span>
                    <Loader title="Loading Review" />
                </div>}
                {/*@ts-ignore*/}
                {this.state.reviews.length > 0 && <Reviews
                    contextUser={this.props.userId}
                    //@ts-ignore
                    employee={this.state.employee}
                    doublePanelRef={null}
                    updateEmployee={this.getEmployeeData}
                    detailedEmployeeData={this.state.employee}
                    raised={false}
                    readOnly={true}
                    ReviewID={props.ReviewID}
                    addOrUpdateNotification={props.setCompleted}
                    // isDelegation={this.state.isDelegation}
                    // delegatorEmployeeId={this.state.delegatorEmployeeId}
                />}
            </div>
        )
    }
}

const mapStateToProps = (state: AppState) => ({
    userId: state.user.userId,
})

export default connect(mapStateToProps)(ReviewsDecoupler)